import { CreatePropertyOptionsWidget } from "../../createProperty/CreatePropertyOptionsWidget";
import { FormConfiguration } from "../../shared/crud/form";
import { PropertyTickersListSelector } from "../../shared/widgets/propertyTickersListSelector";
import { messages } from "../messages";
import { ReplicatePropertyEntity } from "./replicateProperty.entity";

export function buildFormConfiguration(): FormConfiguration<ReplicatePropertyEntity> {
  return {
    __fieldOrder: ["originPropertyTicker", "targetPropertyTicker", "options"],
    originPropertyTicker: {
      messages: {
        label: messages.originPropertyTicker,
      },
      widget: PropertyTickersListSelector,
    },
    targetPropertyTicker: {
      messages: {
        label: messages.targetPropertyTicker,
      },
    },
    options: {
      messages: {
        label: messages.options,
      },
      fieldWidget: CreatePropertyOptionsWidget,
    },
  };
}
